"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableHead = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var ThemedComponent_1 = require("../ThemedComponent");
var TableHead = function (_a) {
    var children = _a.children, branding = _a.branding, variant = _a.variant, testId = _a["data-testid"];
    return ((0, jsx_runtime_1.jsx)(ThemedComponent_1.ThemedComponent, __assign({ as: "thead", "data-testid": testId || 'tableHead', backgroundColor: variant, branding: branding }, { children: children })));
};
exports.TableHead = TableHead;
